// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3COL8","right":"Footer_right__3P459","buttons":"Footer_buttons__3V54S"};